// Identifier cookies set by the ad-pixel base scripts (Meta + LinkedIn). Deleting
// them removes the stable ids that make retargeting possible. Best-effort — we
// only expire the ones actually present.
const PIXEL_COOKIES = [
  '_fbp',
  '_fbc',
  'li_gc',
  'li_mc',
  'lidc',
  'bcookie',
  'bscookie',
  'UserMatchHistory',
  'AnalyticsSyncHistory',
];

/**
 * Expire a cookie across the domain variants it could have been set on: host-only,
 * the current host, and the registrable apex (`.dociohealth.com`) where the
 * cross-subdomain pixel/analytics cookies live.
 */
function deleteCookie(name: string): void {
  const host = window.location.hostname;
  const labels = host.split('.');
  const apex = labels.length > 2 ? labels.slice(-2).join('.') : host;
  const domains = [undefined, host, `.${host}`, apex, `.${apex}`];
  const expiry = 'Thu, 01 Jan 1970 00:00:00 GMT';
  for (const domain of domains) {
    document.cookie =
      `${name}=; expires=${expiry}; path=/` + (domain ? `; domain=${domain}` : '');
  }
}

export function clearPixelCookies(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  for (const name of PIXEL_COOKIES) {
    try {
      deleteCookie(name);
    } catch {
      // Ignore individual cookie failures; keep clearing the rest.
    }
  }
}
